export default __webpack_public_path__ + "static/media/G0004.0a4fa968.png";